<template>
  <div v-bind="$attrs">
    <header class="mb-4">
      <h2 class="text-2xl font-semibold text-blue-500">{{ headline }}</h2>
    </header>
    <div class="grid md:grid-cols-2 xl:grid-cols-3 gap-10 items-start">
      <template v-for="(event, key) in events" :key="event.id">
        <Card
          background="bg-gray-800"
          :image="event.cover"
          :link="route('events.show', [event])"
          :alt="event.name"
        >
          <template #caption>
            <strong class="text-lg font-semibold">{{ event.name }}</strong><br>
            <span>{{ event.short_desc }}</span>
          </template>
          <template #footer>
            <a v-if="event.link" :href="event.link" target="_blank" class="text-blue-500 underline text-sm mb-4 sm:mb-0">
              Mehr erfahren
            </a>
            <Link
              :href="route('events.show', [event])"
              class="button button--ghost text-blue-500 ml-auto w-full sm:w-auto"
              text="Termin wählen"
            />
          </template>
        </Card>
      </template>
    </div>
  </div>
</template>

<script>
import Card from 'Web/Shared/Card.vue';
import Link from 'Web/Shared/Link.vue';

export default {
  inheritAttrs: false,
  components: {
    Card,
    Link,
  },
  props: {
    events: {
      type: Array,
      required: true,
    },
    headline: {
      type: String,
      default: 'Veranstaltungen',
    },
  }
}
</script>
